(function() {
    'use strict';
    angular
        .module('emarket.main.profile')
        .controller('ProfileEditController', ['$rootScope', '$mdDialog', '$mdPanel', '$q', '$log', '$scope', 'Announcer', 'File', 'Auth', 'Profile', 'Province', 'Category', function($rootScope,
            $mdDialog,
            $mdPanel,
            $q,
            $log,
            $scope,
            Announcer,
            File,
            Auth,
            Profile,
            Province,
            Category) {
            var vm = this;
            vm.password = '******';
            var file;
            vm.user = Auth.getUser();
            var profile;
            var announcer = Announcer.create($scope);
            announcer.emit(Profile.events.HIDE_NAV_BAR);
            announcer.emit(Profile.events.HIDE_STAT_CARD);
            announcer.on(Profile.events.PROFILE_PICTURE_UPLOAD, function(ev, picture) {
                file = picture;
            });
            vm.provinces = Province.$search();
            vm.phoneTypes = Profile.phone.types;
            vm.phoneStatus = Profile.phone.status;

            var getProfile = function() {
                if (profile) {
                    return $q.when(profile);
                } else {
                    return Profile.$find(vm.user._id)
                        .$asPromise()
                        .then(function(p) {
                            profile = p;
                            return p;
                        });
                }
            };

            var _save = function(properties) {
                vm.loading = true;
                var promise = $q.when();
                if (file) {
                    promise = File.create(file);
                }
                return promise
                    .then(function(file) {
                        vm.user.picture = file;
                    })
                    .then(function() {
                        return getProfile();
                    })
                    .then(function(profile) {
                        properties = properties || [
                            'displayName',
                            'address',
                            'picture',
                            'emails',
                            'phones',
                            'store'
                        ];
                        properties.forEach(function(key) {
                            if (vm.user[key]) {
                                profile[key] = vm.user[key];
                            }
                        });

                        return profile.$save(properties).$asPromise();
                    })
                    .then(function(user) {
                        vm.loading = false;
                        return user;
                    })
                    .catch(function(err) {
                        vm.loading = false;
                        $log.error(err);
                        throw err;
                    });
            };

            var savePhone = function() {
                return _save([ 'phones' ]).then(function(user) {
                    Auth.setUser(user);
                });
            };

            vm.addPhone = function() {
                if (vm.phone && vm.phone.number && vm.phone.type) {
                    vm.phone.status = vm.phoneStatus.VALIDATED;

                    vm.user.phones.unshift(vm.phone);

                    vm.phone = {};
                    return savePhone().catch(function() {
                        vm.user.phones.pop();
                    });
                }
                if (!vm.phone || !vm.phone.type) {
                    vm.showPhoneTypeError = true;
                }
            };
            vm.showChangePasswordDialog = function() {
                Profile.showChangePasswordDialog(vm.user);
            };
            vm.removePhone = function(index) {
                var phone = vm.user.phones[index];
                var confirm = $mdDialog
                    .confirm()
                    .title('¿Seguro que deseas borrar el número ' + phone.number + '?')
                    .content('Esto no puede deshacerse y deberas validar nuevamente este número en caso de querer agregarlo')
                    .ok('Si, Eliminar')
                    .cancel('Cancelar')
                    .ariaLabel('Dialogo de borrado de número teléfonico');
                $mdDialog.show(confirm).then(function() {
                    vm.user.phones.splice(index, 1);
                    savePhone();
                });
            };

            var savingSuccess = function(user) {
                Auth.setUser(user);
                announcer.emit(Auth.USER_CHANGE);
            };
            vm.save = function() {
                _save().then(savingSuccess);
            };
            vm.validatePhone = function(phone) {
                Profile.showPhoneValidationDialog(phone).then(function() {
                    vm.user.phones.forEach(function(p) {
                        if (p.number === phone.number) {
                            p.status = Profile.phone.status.VALIDATED;
                        }
                    });
                });
            };

            vm.categories = Category.$search({ parentId: 0 });
            vm.uploadStoreCoverPicture = function(file) {
                var success = function(response) {
                    $log.debug('Upload complete', response);
                    vm.user.store.cover.image = response;
                };
                var progress = function(event) {
                    var progressPercentage = parseInt(100 * event.loaded / event.total);
                    $log.debug('progressPercentage %s', progressPercentage);
                };
                var error = function(err) {
                    $log.error(err);
                };
                return File.create(file).then(success, error, progress);
            };

            vm.showMainAdvertising = function() {
                var panel = {
                    templateUrl: 'main/profile/edit/main.advertising.panel.tpl.html',
                    panelClass: 'main-advertising-panel',
                    controllerAs: 'vm',
                    zIndex: 65,
                    controller: [
                        'mdPanelRef',
                        'categories',
                        'profile',
                        function(mdPanelRef, categories, profile) {
                            var vm = this;
                            $log.info(categories);
                            vm.categories = categories;

                            vm.user = profile;
                            vm.close = function() {
                                mdPanelRef.close({
                                    store: vm.user.store,
                                    file: vm.storeCoverPicture
                                });
                            };
                            vm.dismiss = function() {
                                mdPanelRef.close();
                            };
                        }
                    ],
                    resolve: {
                        categories: function() {
                            return vm.categories.$asPromise();
                        },
                        profile: function() {
                            return getProfile();
                        }
                    },
                    onOpenComplete: function() {
                        // $rootScope.$emit('scroll:disable', true);
                        announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
                    },
                    onCloseSuccess: function(ev, response) {
                        // $rootScope.$emit('scroll:disable');
                        announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR, false);
                        if (response) {
                            vm.user.store = response.store;
                            var promise = $q.resolve();
                            if (response.file) {
                                promise = vm.uploadStoreCoverPicture(response.file);
                            }
                            promise
                                .then(function() {
                                    return _save([ 'store' ]);
                                })
                                .then(function() {
                                    $log.info('upload complete');
                                })
                                .catch(function(err) {
                                    $log.error('upload failed');
                                    $log.error(err);
                                });
                        }
                    }
                };
                $mdPanel.open(panel);
            };
        }]);
}());
